export const GAME_MODES = {
  ROYALE: "royale",
  PVE: "pve",
  TEAMS: "teams", // not fully implemented yet
  // BOSS: "boss", etc.
  // RAID: "raid", etc.
  // DUEL: "duel", 
};

export const MODE_CONFIGS = {
  [GAME_MODES.ROYALE]: {
    id: GAME_MODES.ROYALE,
    label: "Royale",
    iconKey: "swords",
    isCoop: false,
    hasTeams: false,
    victoryCondition: "last_player",
  },
  [GAME_MODES.PVE]: {
    id: GAME_MODES.PVE,
    label: "PvE",
    iconKey: "shield_star",
    isCoop: true,
    hasTeams: false,
    victoryCondition: "humans_vs_bots",
  },
  [GAME_MODES.TEAMS]: {
    id: GAME_MODES.TEAMS,
    label: "Teams",
    iconKey: "both",
    isCoop: false,
    hasTeams: true,
    victoryCondition: "last_team",
  },
};

export function getModeFromRoom(room) {
  if (room?.mode) return room.mode;
  return GAME_MODES.ROYALE;
}
